import React from "react";
import { Link } from "react-router-dom";

const ScrollToTopLink = ({ to, children }) => {
    const handleClick = () => {
        window.scrollTo(0, 0);
    };

    return (
        <Link to={to} className="nav-link p-0 text-body-secondary mb-2" onClick={handleClick}>
            {children}
        </Link>
    );
};

function Footer() {

    return (
        <>
            <div className="container">
                <footer className="row row-cols-1 row-cols-sm-2 row-cols-md-4 pt-4 mb-3 border-top justify-content-around">
                    <div className="col d-flex flex-column align-items-center justify-content-center">
                        <img src='/logo.webp' loading="lazy" alt="logo" className="img-fluid col-md-11 col-sm-8 col-5" />
                        <div className="d-flex flex-row align-items-center">
                            <p className="text-body-secondary m-0 me-2">&copy; 2024</p>
                                <a href="https://www.facebook.com/profile.php?id=100057441498402" className="fs-3 me-2" target="_blank" rel="noopener noreferrer"><i class="bi bi-facebook"></i></a>
                                <a href="https://www.instagram.com/kreativoromok/" className="fs-3" target="_blank" rel="noopener noreferrer"><i class="bi bi-instagram"></i></a>
                            </div>
                    </div>

                    <div className="col mb-sm-2">
                        <h6>Oldaltérkép</h6>
                        <ul className="nav flex-column">
                            <li><ScrollToTopLink to="/">Kezdőlap</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/products/prepared_materials">Kézműves csomagok</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/products/finished_products">Kész termékek</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/products/materials" >Alapanyagok</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/guides">Útmutatók</ScrollToTopLink></li>

                        </ul>
                    </div>

                    <div className="col mb-2">


                        <ul className="nav pt-sm-3 flex-column">
                            <li><ScrollToTopLink to="/contact">Rólam/Kapcsolat</ScrollToTopLink></li>
                            <li><a className="nav-link p-0 text-body-secondary mb-2" href="/Aszf.pdf" target="_blank" rel="noopener noreferrer">Általános Szerződési Feltételek</a></li>
                            <li><a className="nav-link p-0 text-body-secondary mb-2" href="/Adatvedelmi.pdf" target="_blank" rel="noopener noreferrer">Adatkezelési Tájékoztató</a></li>
                            <li><a className="nav-link p-0 text-body-secondary mb-2" href="/Cookies.pdf" target="_blank" rel="noopener noreferrer">Cookie nyilatkozat</a></li>
                        </ul>
                    </div>

                    <div className="col mb-2">
                        <h6>Vásárlás</h6>
                        <ul className="nav flex-column">
                            <li><ScrollToTopLink to="/login">Bejelentkezés</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/registration">Regisztráció</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/basket">Kosár</ScrollToTopLink></li>
                            <li><ScrollToTopLink to="/deliveryinfo">Szállítás és fizetés</ScrollToTopLink></li>
                            <div className="d-flex flex-row align-items-center">
                                <img style={{maxHeight: '25px' }} src="/stripe.webp" loading="lazy" alt="stripe logo"/>
                                <img style={{maxHeight: '25px' }} src="/visa-logo.webp" loading="lazy" alt="visa logo"/>
                                <img style={{maxHeight: '25px' }} className="mx-2" src="/Mastercard-logo.webp" loading="lazy" alt="mastercard logo"/>
                            </div>
                        </ul>
                    </div>
                </footer>
            </div>

        </>
    );
}

export default Footer;
